import script from "./Carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=2bffbf9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bffbf9f"]])

export default __exports__